import { Box, Drawer, useMantineColorScheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { ReactNode } from "react";

interface SidePanelShellProps {
    onClose: () => void;
    children: ReactNode;
}

/**
 * Shared side-panel chrome — a full-screen Drawer on mobile, a fixed right-hand panel on desktop —
 * extracted from CVList's inline wrapper around CVPreviewSidebar so Employee Overview's
 * EmployeeOnlyPanel can share identical positioning without duplicating it. Callers are
 * responsible for only rendering this while a selection is active (mirrors CVList's existing
 * `{selectedPersonId && (...)}` gating), so there is no open/close exit animation here.
 */
export function SidePanelShell({ onClose, children }: SidePanelShellProps) {
    const isMobile = useMediaQuery("(max-width: 768px)");
    const { colorScheme } = useMantineColorScheme();
    const isDark = colorScheme === "dark";

    if (isMobile) {
        return (
            <Drawer
                opened
                onClose={onClose}
                position="right"
                size="100%"
                withCloseButton={false}
                padding={0}
                styles={{ body: { padding: 0, height: "100%" } }}
            >
                {children}
            </Drawer>
        );
    }

    return (
        <Box
            style={{
                position: "fixed",
                top: "60px",
                right: 0,
                width: "400px",
                height: "calc(100vh - 60px)",
                zIndex: 100,
                boxShadow: "-2px 0 10px rgba(0, 0, 0, 0.1)",
                background: isDark ? "var(--mantine-color-dark-7)" : "white",
            }}
        >
            {children}
        </Box>
    );
}
